import { useCallback, useState } from 'react';

export enum LoadingState {
	idle = 'idle',
	loading = 'loading',
	fetching = 'fetching',
	refreshing = 'refreshing',
}

const useLoadingState = (initialState: LoadingState = LoadingState.loading) => {
	const [loadingState, setLoadingState] = useState<LoadingState>(initialState);

	const setIsLoading = useCallback(() => {
		setLoadingState(LoadingState.loading);
	}, []);

	const setIsIdle = useCallback(() => {
		setLoadingState(LoadingState.idle);
	}, []);

	const setIsFetching = useCallback(() => {
		setLoadingState(LoadingState.fetching);
	}, []);

	return {
		loadingState,
		setLoadingState,
		setIsLoading,
		setIsIdle,
		setIsFetching,
		isIdle: loadingState === LoadingState.idle,
		isLoading: loadingState === LoadingState.loading,
		isFetching: loadingState === LoadingState.fetching,
		isRefreshing: loadingState === LoadingState.refreshing,
	};
};

export default useLoadingState;
